import React from 'react';
import MyCard from "../../components/myCard";
import {Button, Col, Row} from "react-bootstrap";
import {Get, Post} from "../../components/request";
import screens from "../../screens";
import ScreenComponent from "../../components/screenComponent";
import {withRouter} from "react-router-dom";
import {getRoute} from "../../breadcrumb/utils";
import {default as RemiseMemoireForm} from "../../forms/remiseMemoire";
import loadParameters from "../../components/loadParameters";
import {isObject} from "lodash";

class RemiseMemoire extends ScreenComponent {
    constructor(props) {
        super(props);
        this.state = {
            validateForm: false,
            memoire: {
                Remis: true,
            },
            canUploadTwice: false,
        }

        this.state.parameters = [];
        this.state.parameters["DisciplineMemoireID"] = [];
        this.state.parameters["MembrePersonnelID"] = [];
        this.state.parameters["SessionID"] = [];
    }

    async componentDidMount() {
        super.componentDidMount();

        await loadParameters(this, "DisciplineMemoireID, MembrePersonnelID, SessionID");

        const {body} = await Get(`/v1/extranet/student/${screens.RemiseMemoire}`);

        if (!body.MemoireConsentement) {
            this.props.history.push(getRoute(screens.Consentement));
        }

        const get = await Get(`/v1/extranet/student/canUploadSecondeSession/${body.MemoireID}`);

        this.setState({
            memoire: body,
            canUploadTwice: get.body,
        });
    }

    async save(data, secondeSession) {
        data["MemoireID"] = this.state.memoire.MemoireID;

        Object.entries(data).forEach(([key, value]) => {
            if (isObject(value)) data[key] = value.value
        });

        await Post(`/v1/extranet/student/MemoireRemise${secondeSession ? "SecondeSession" : ""}`, data, "Sauvegarde en cours..", {render: "Mémoire sauvegardé !"}, {render: "Erreur lors de la sauvegarde"});

        this.componentDidMount();
    }


    renderRemiseText() {
        return (
            <>
                <p>
                    Les informations finales de votre mémoire ont bien été enregistrées.
                </p>

                <u>Titre définitif</u>:
                <h4>« {this.state.memoire.MemoireTitreDefinitif} »</h4>
                <p>
                    <u>Discipline</u>: {this.state.memoire.DisciplineMemoire}
                </p>
                <p>
                    <u>Promoteur</u>: {this.state.parameters.MembrePersonnelID.filter(f => f.value === this.state.memoire.MembrePersonnelID).map(m => m.label)}
                </p>
                <p>
                    <u>Session</u>: {this.state.parameters.SessionID.filter(f => f.value === this.state.memoire.SessionID).map(m => m.label)}
                </p>


                <div className="text-right">
                    <Button className="mr-3" variant={"outline-primary"} size={"lg"}
                            target={"_blank"}
                            href={`${process.env.APP_API_ENDPOINT}/v1/files/${this.state.memoire.MemoireFichierMemoireSansAnnexesID}`}>Mémoires
                        sans annexes</Button>
                    <Button size={"lg"} variant={"outline-primary"}
                            target={"_blank"}
                            href={`${process.env.APP_API_ENDPOINT}/v1/files/${this.state.memoire.MemoireFichierMemoireAvecAnnexesID}`}>Mémoires
                        avec annexes</Button>
                </div>
            </>
        )
    }

    render() {
        return (
            <section>
                {this.state.memoire.Remis
                    ? <>
                        <MyCard header={"Mémoire final"}
                                body={this.renderRemiseText()}/>
                        <br/>
                    </>
                    : <>
                        <RemiseMemoireForm onSubmit={this.save.bind(this)}
                                           secondeSession={false}
                                           parameters={this.state.parameters}/>
                        <br/>
                    </>
                }
                {/* #13422
                {this.state.canUploadTwice && <RemiseMemoireForm onSubmit={this.save.bind(this)}
                                                                 secondeSession={true}
                                                                 parameters={this.state.parameters}/>}
                */}
            </section>
        );
    }
}

export default withRouter(RemiseMemoire);